import Validatable from '@/validator/Validatable';

export interface IReachAndFrequencyStatisticsAPI {
  frames: number;
  spot: number;
  period_days: number;
  base_segment: string;
  target_segment: string;
  target_geo: string;
  market: string;
  index_comp_target: number;
  pct_comp_pop_target_inmkt: number;
  pct_comp_imp_target: number;
  pct_comp_imp_target_inmkt: number;
  freq_avg: number;
  imp_target_inmkt: number;
  imp_target: number;
  imp_inmkt: number;
  imp: number;
  pct_imp_inmkt: number;
  pct_imp_target_inmkt: number;
  pop_inmkt: number;
  pop_target_inmkt: number;
  reach_pct: number;
  reach_net: number;
  trp: number;
  eff_freq_min: number;
  eff_freq_avg: number;
  eff_reach_net: number;
  eff_reach_pct: number;
  product_name: string;
  measures_release: string;
}

export default class ReachAndFrequencyStatistics extends Validatable {
  frames: number;

  spot: number;

  periodDays: number;

  baseSegment: string;

  targetSegment: string;

  targetGeo: string;

  market: string;

  indexCompTarget: number;

  pctCompPopTargetInmkt: number;

  pctCompImpTarget: number;

  pctCompImpTargetInmkt: number;

  freqAvg: number;

  impTargetInmkt: number;

  impTarget: number;

  impInmkt: number;

  imp: number;

  pctImpInmkt: number;

  pctImpTargetInmkt: number;

  popInmkt: number;

  popTargetInmkt: number;

  reachPct: number;

  reachNet: number;

  trp: number;

  effFreqMin: number;

  effFreqAvg: number;

  effReachNet: number;

  effReachPct: number;

  productName: string;

  measuresRelease: string;

  constructor(
    frames: number,
    spot: number,
    periodDays: number,
    baseSegment: string,
    targetSegment: string,
    targetGeo: string,
    market: string,
    indexCompTarget: number,
    pctCompPopTargetInmkt: number,
    pctCompImpTarget: number,
    pctCompImpTargetInmkt: number,
    freqAvg: number,
    impTargetInmkt: number,
    impTarget: number,
    impInmkt: number,
    imp: number,
    pctImpInmkt: number,
    pctImpTargetInmkt: number,
    popInmkt: number,
    popTargetInmkt: number,
    reachPct: number,
    reachNet: number,
    trp: number,
    effFreqMin: number,
    effFreqAvg: number,
    effReachNet: number,
    effReachPct: number,
    productName: string,
    measuresRelease: string,
  ) {
    super();

    this.frames = frames;
    this.spot = spot;
    this.periodDays = periodDays;
    this.baseSegment = baseSegment;
    this.targetSegment = targetSegment;
    this.targetGeo = targetGeo;
    this.market = market;
    this.indexCompTarget = indexCompTarget;
    this.pctCompPopTargetInmkt = pctCompPopTargetInmkt;
    this.pctCompImpTarget = pctCompImpTarget;
    this.pctCompImpTargetInmkt = pctCompImpTargetInmkt;
    this.freqAvg = freqAvg;
    this.impTargetInmkt = impTargetInmkt;
    this.impTarget = impTarget;
    this.impInmkt = impInmkt;
    this.imp = imp;
    this.pctImpInmkt = pctImpInmkt;
    this.pctImpTargetInmkt = pctImpTargetInmkt;
    this.popInmkt = popInmkt;
    this.popTargetInmkt = popTargetInmkt;
    this.reachPct = reachPct;
    this.reachNet = reachNet;
    this.trp = trp;
    this.effFreqMin = effFreqMin;
    this.effFreqAvg = effFreqAvg;
    this.effReachNet = effReachNet;
    this.effReachPct = effReachPct;
    this.productName = productName;
    this.measuresRelease = measuresRelease;
  }

  static fromApi(apiObj: IReachAndFrequencyStatisticsAPI): ReachAndFrequencyStatistics {
    if (!apiObj) return null;

    return new ReachAndFrequencyStatistics(
      apiObj.frames,
      apiObj.spot,
      apiObj.period_days,
      apiObj.base_segment,
      apiObj.target_segment,
      apiObj.target_geo,
      apiObj.market,
      apiObj.index_comp_target,
      apiObj.pct_comp_pop_target_inmkt,
      apiObj.pct_comp_imp_target,
      apiObj.pct_comp_imp_target_inmkt,
      apiObj.freq_avg,
      apiObj.imp_target_inmkt,
      apiObj.imp_target,
      apiObj.imp_inmkt,
      apiObj.imp,
      apiObj.pct_imp_inmkt,
      apiObj.pct_imp_target_inmkt,
      apiObj.pop_inmkt,
      apiObj.pop_target_inmkt,
      apiObj.reach_pct,
      apiObj.reach_net,
      apiObj.trp,
      apiObj.eff_freq_min,
      apiObj.eff_freq_avg,
      apiObj.eff_reach_net,
      apiObj.eff_reach_pct,
      apiObj.product_name,
      apiObj.measures_release,
    );
  }
}
